import { FC, ReactNode } from 'react'
import { IconType } from 'react-icons'

interface Props {
  title: string
  icon?: IconType
  rightSlot?: ReactNode
  children: ReactNode
  noPadding?: boolean
}

const SectionShell: FC<Props> = ({ title, icon: Icon, rightSlot, children, noPadding }) => (
  <section className='bg-white border border-neutral-200 rounded-xl'>
    <header className='flex items-center justify-between gap-3 px-5 pt-5 pb-3'>
      <div className='flex items-center gap-1.5'>
        {Icon && <Icon size={14} className='text-neutral-500' />}
        <p className='text-[11px] font-semibold tracking-widest uppercase text-neutral-500'>
          {title}
        </p>
      </div>
      {rightSlot}
    </header>
    <div className={noPadding ? '' : 'px-5 pb-5'}>
      {children}
    </div>
  </section>
)

export default SectionShell
